import React from "react";
import {ContentHeader} from './contentheader';
import {ContentSets} from './contentsets';
import {ContentSet, MAX_NUM_ITEMS} from "./contentset";
import ContentFinder, { FinderState, getEmptyFinderState } from "./contentfinder";
import { ContentSetLink } from "./contentsetlink";
import ContentAudio from './content-audio/contentaudio';

export enum ContentStatus{
    Default='DEFAULT',
    GetList='GETLIST',
    GetListError='GETLISTERROR',
    GetSet='GETSET',
    GetSetError='GETSETERROR',
    SaveSet='SAVESET',
    SaveSetError='SAVESETERROR',
    DeleteSet='DELETESET',
    DeleteSetError='DELETESETERROR'
}

const NOT_LOGGED_IN:React.ReactElement=<p className="teachers-statusmessage">Not logged in</p>;

// const DEFAULT_AUDIO_VOICE:number=1;//British female
const DEFAULT_AUDIO_VOICE:number=2;//US male

export interface ContentSetData{
    myID:number;
	title:string;
	imsList:string[];
	txtsList:string[];
    options:{optID:string,optVal:number}[];
    // options:ContentOption[];
}

export const getEmptyContentData=function():ContentSetData{
    // return {title:'', imsList:[],  txtsList:[], audioVoice:1, options:[]}
    return {title:'', imsList:[],  txtsList:[], options:[{optID:'audio',optVal:DEFAULT_AUDIO_VOICE}], myID:-1}
}

// interface ContentOption{optID:string,optVal:number}

interface PropsType{
    usermail:string;
    isEdited:boolean;
    isContentSetNew:boolean;
    contentStatus:ContentStatus;
	isLoggedIn:boolean;
    userContentList:string[];
    contentSetData:ContentSetData;
    getContentSet:Function;
    newContentSet:Function;
    updateContentSet:Function;
    contentSetMenuClick:Function;
}

interface StateType{
    finderState:FinderState
}

export default class Content extends React.Component<PropsType>{

    public state:StateType;

    constructor(props:PropsType){
        super(props);

        this.contentFinderClick=this.contentFinderClick.bind(this);
        this.removeItemClick=this.removeItemClick.bind(this);
        this.contentSetItemTextChange=this.contentSetItemTextChange.bind(this);
        this.updateContentSetTitle=this.updateContentSetTitle.bind(this);
        this.selectAudio=this.selectAudio.bind(this);
        this.contentSetClick=this.contentSetClick.bind(this);
        this.updateFinderState=this.updateFinderState.bind(this);
        this.newSetClick=this.newSetClick.bind(this);
        
        this.state={
            finderState:getEmptyFinderState()
        }
    }

    contentFinderClick(itemCode:string,itemText:string){
        if(this.props.contentSetData.imsList.length>=MAX_NUM_ITEMS)return;
		if(this.props.contentSetData.imsList.indexOf(itemCode)===-1){
            let newContentSetData=this.props.contentSetData;
            newContentSetData.imsList.push(itemCode);
            newContentSetData.txtsList.push(itemText);
            this.props.updateContentSet(newContentSetData);
		}
    }

    updateFinderState(finderState:FinderState){
        this.setState({finderState:finderState});
    }

    resetFinderState(){
        this.setState({finderState:getEmptyFinderState()});
    }

    newSetClick(){
        this.resetFinderState();
        this.props.newContentSet();
    }

    contentSetItemTextChange(itemIndex:number, itemText:string){
		let cleanText = itemText.replace(/[^a-zA-Z0-9'?!&,.@ ]/g, "");
        let newContentSetData=this.props.contentSetData;
        newContentSetData.txtsList[itemIndex]=cleanText;
        this.props.updateContentSet(newContentSetData);
    }

    removeItemClick(delItem:string){
        let delItemIndex=this.props.contentSetData.imsList.indexOf(delItem);
		if(delItemIndex!==-1){
            let newContentSetData=this.props.contentSetData;
            newContentSetData.imsList.splice(delItemIndex,1);
            newContentSetData.txtsList.splice(delItemIndex,1);
            this.props.updateContentSet(newContentSetData);
		}
    }

    updateContentSetTitle(newTitle:string){
		let cleanText = newTitle.replace(/ /g, "_");
		cleanText = cleanText.replace(/[^a-zA-Z0-9_]/g, "");
        let newContentSetData=this.props.contentSetData;
        newContentSetData.title=cleanText;
        this.props.updateContentSet(newContentSetData);
    }

    selectAudio(audioIndex:number){
        let myOptions=this.props.contentSetData.options;
        for(let i=0;i<myOptions.length;i++){
            if(myOptions[i].optID==='audio')myOptions[i].optVal=audioIndex;
        }
        let newContentSetData=this.props.contentSetData;
        newContentSetData.options=myOptions;
        this.props.updateContentSet(newContentSetData);
    }

    contentSetClick(contentSet:string){
        this.resetFinderState();
        this.props.getContentSet(contentSet);
    }

    render(): React.ReactNode {
		// if(this.props.isLoggedIn===false)return NOT_LOGGED_IN;

        let showAll=true;
        if(this.props.contentStatus===ContentStatus.GetList)showAll=false;
        if(this.props.contentStatus===ContentStatus.GetSet)showAll=false;
        if(this.props.contentStatus===ContentStatus.SaveSet)showAll=false;
        if(this.props.contentStatus===ContentStatus.DeleteSet)showAll=false;

        let showVoice=showAll&&this.props.contentSetData.imsList.length>=5;

        let audioChosen=1;
        for(let i=0;i<this.props.contentSetData.options.length;i++){
            if(this.props.contentSetData.options[i].optID==='audio'){
                audioChosen=this.props.contentSetData.options[i].optVal;
            }
        }

        return(
            <div className='teachers-content'>
                <hr />
                <ContentHeader />
                <ContentSets 
                    isLoggedIn={this.props.isLoggedIn}
                    isContentSetNew={this.props.isContentSetNew}
                    contentStatus={this.props.contentStatus}
                    userContentList={this.props.userContentList} 
                    contentSetClick={this.contentSetClick}
                    newSetClick={this.newSetClick}/>
                <ContentFinder 
	                finderState={this.state.finderState}
	                updateFinderState={this.updateFinderState}
                    isContentSetNew={this.props.isContentSetNew}
                    contentSetDataImsList={this.props.contentSetData.imsList}
                    showFinder={showAll}
                    contentFinderClick={this.contentFinderClick}/>
                <ContentSet 
                    showAll={showAll}
                    isLoggedIn={this.props.isLoggedIn}
                    contentSetItemTextChange={this.contentSetItemTextChange}
                    userContentList={this.props.userContentList} 
                    removeItemClick={this.removeItemClick}
                    contentSetMenuClick={this.props.contentSetMenuClick}
                    contentStatus={this.props.contentStatus}
                    updateContentSetTitle={this.updateContentSetTitle}
                    contentSetData={this.props.contentSetData}
                    isContentSetNew={this.props.isContentSetNew}/>
                <ContentAudio
                    showVoice={showVoice}
                    txtsList={this.props.contentSetData.txtsList}
                    audioChosen={audioChosen}
                    selectAudio={this.selectAudio}
                    />
                <ContentSetLink 
                    contentStatus={this.props.contentStatus}
                    usermail={this.props.usermail}
                    contentSetData={this.props.contentSetData}
                    isEdited={this.props.isEdited}/>
            </div>
        );
    }
}